<template>
  <v-row>
    <v-col class="col-2 pr-0">
      <v-tabs v-model="activeTab" vertical>
        <v-tab
          v-show="hasOverviewComplete"
          :key="1"
          :href="`#tab-${1}`"
          class="justify-start"
        >
          <i class="fas fa-user" />
          {{ $t('shopBackendBookingOverview.calendar') }}
        </v-tab>
        <v-tab :key="2" :href="`#tab-${2}`" class="justify-start">
          <i class="fas fa-user" />
          {{ $t('shopBackendBookingOverview.byCustomer') }}
        </v-tab>
        <v-tab
          v-show="hasOverviewComplete"
          :key="3"
          :href="`#tab-${3}`"
          class="justify-start"
        >
          <i class="fas fa-users" />
          {{ $t('shopBackendBookingOverview.all') }}
        </v-tab>
        <v-tab
          v-show="hasOverviewAggregated"
          :key="4"
          :href="`#tab-${4}`"
          class="justify-start"
        >
          <i class="fas fa-sigma" />
          {{ $t('shopBackendBookingOverview.aggregated') }}
        </v-tab>
      </v-tabs>
    </v-col>
    <v-col class="col-10 pl-0">
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-show="hasOverviewComplete" :key="1" :value="`tab-${1}`">
          <booking-calendar />
        </v-tab-item>
        <v-tab-item :key="2" :value="`tab-${2}`">
          <booking-by-customer-search
            create-booking
            :selected-user-bookings.sync="selectedUserBookings"
          />
        </v-tab-item>
        <v-tab-item v-show="hasOverviewComplete" :key="3" :value="`tab-${3}`">
          <booking-complete
            v-if="hasOverviewComplete"
            ref="bookingComplete"
            :filters.sync="bookingCompleteFilters"
            :date-range-input.sync="bookingCompleteDateRange"
            :options="bookingCompleteOptions"
            @update:dateRange="
              (dateRange) => BookingCompleteDateRangeChanged(dateRange)
            "
            @update:options="updateBookingCompleteOptions"
          />
        </v-tab-item>
        <v-tab-item v-show="hasOverviewAggregated" :key="4" :value="`tab-${4}`">
          <booking-aggregated v-if="hasOverviewAggregated" />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import BookingByCustomerSearch from './BookingByCustomerSearch'
import BookingComplete from './BookingsComplete'
import BookingAggregated from './BookingAggregated'
import definitions from '../../../definitions'
import BookingCalendar from './BookingCalendar'
import NavigationStoreMixin from '../../components-shared/mixins/NavigationStoreMixin'
export default {
  name: 'BookingOverviewTabs',
  components: {
    BookingCalendar,
    BookingAggregated,
    BookingComplete,
    BookingByCustomerSearch,
  },
  mixins: [NavigationStoreMixin],
  data() {
    return {
      activeTab: 'tab-2', // this tab is always available
      // for BookingByCustomerSearch.vue
      selectedUserBookings: null,
      // for BookingComplete
      bookingCompleteFilters: {
        product: null,
        productDefinition: null,
        customer: null,
        time: null,
        bookingState: null,
        paymentState: null,
      },
      // for BookingComplete
      bookingCompleteOptions: {},
      bookingCompleteDateRange: {
        from: new Date(),
        to: new Date(),
      },
    }
  },

  asyncComputed: {
    // short cut
    async hasOverviewComplete() {
      if (this.$store.getters.getAppUserInstance()) {
        return await this.$store.getters
          .getAppUserInstance()
          .doIHavePermissionInTheCurrentDestinationForKey(
            definitions.permissions.frontend
              .FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_COMPLETE
          )
      }
      return false
    },

    // short cut
    async hasOverviewAggregated() {
      if (this.$store.getters.getAppUserInstance()) {
        return await this.$store.getters
          .getAppUserInstance()
          .doIHavePermissionInTheCurrentDestinationForKey(
            definitions.permissions.frontend
              .FRONTEND_ACCESS_SHOP_BOOKING_OVERVIEW_AGGREGATED
          )
      }
      return false
    },
  },

  watch: {
    // save active tab in navigation store
    activeTab() {
      this.storeObject['activeTab'] = this.activeTab
    },
    selectedUserBookings() {
      this.storeObject['selectedUserBookings'] = this.selectedUserBookings
    },
    bookingCompleteFilters: {
      deep: true,
      handler() {
        this.storeObject['bookingCompleteFilters'] = this.bookingCompleteFilters
      },
    },
  },

  mounted() {
    if (this.storeObject.activeTab) {
      this.$nextTick(() => {
        this.activeTab = this.storeObject.activeTab
      })
    }
    if (this.storeObject.selectedUserBookings)
      this.selectedUserBookings = this.storeObject.selectedUserBookings
    if (this.storeObject.bookingCompleteFilters)
      this.bookingCompleteFilters = this.storeObject.bookingCompleteFilters
    if (this.storeObject.bookingCompleteDateRange)
      this.bookingCompleteDateRange = this.storeObject.bookingCompleteDateRange
  },

  methods: {
    async BookingCompleteDateRangeChanged(dateRange) {
      this.bookingCompleteDateRange = dateRange
      this.storeObject['bookingCompleteDateRange'] = dateRange
      this.$nextTick(async () => {
        await this.$refs.bookingComplete.onFilterOrDateChange()
      })
    },
    // helps to manage the pagination in the BookingsComplete.vue
    updateBookingCompleteOptions(options) {
      if (!options && this.storeObject.bookingCompleteOptions) {
        this.bookingCompleteOptions = this.storeObject.bookingCompleteOptions
      } else if (options) {
        this.storeObject['bookingCompleteOptions'] = options
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fas {
  margin-right: 1rem;
}
</style>
